import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { Outlet } from 'react-router';
import { SubscriptionCategory } from '../../../../common/enums.js';
import { t } from '../../../../common/i18n/index.js';
import { LoadingDialog } from '../../../../components/LoadingDialog/LoadingDialog.js';
import {
  getEmployeeSubscriptions,
  loadVirtualCatalogs,
  setFooterVisibility,
} from '../../../../selfservice/actions/index.js';
import {
  removeActiveAccountMasterId,
  removePrimaryMdmId,
  setActiveAccountMasterId,
  setPrimaryMdmId,
} from '../../../../selfservice/common/localStorageUtils.js';
import { useAuth } from '../../AuthProvider.js';
import { useSessionData } from '../../SessionDataProvider.js';
import { refreshCompanyInfoSession } from '../../sessionDataStore.js';
import type { State } from '../../../../selfservice/common/store.js';

export const PunchoutPath = () => {
  const store = useStore<State>();
  const dispatch = useDispatch();
  const { authenticatedUser } = useAuth();
  const selfservice = store.getState().selfservice;
  const catalogs = Boolean(selfservice?.virtualCatalogs?.items);
  const companyInfo = useSessionData().companyInfo;
  const hasAddress = Boolean(companyInfo?.address);

  useEffect(() => {
    removePrimaryMdmId();
    removeActiveAccountMasterId();
  }, []);

  useEffect(() => {
    if (authenticatedUser?.userRole && authenticatedUser.mdmId) {
      setActiveAccountMasterId(authenticatedUser.mdmId);
      setPrimaryMdmId(authenticatedUser.mdmId);
      dispatch(setFooterVisibility(false));
      const catalogPreSelected = authenticatedUser.enabledFeatureFlags?.includes('catalogPreSelected');
      if (!catalogs) {
        dispatch(loadVirtualCatalogs(undefined, catalogPreSelected));
      }
      if (!hasAddress) {
        void refreshCompanyInfoSession(authenticatedUser.mdmId, false, true);
      }
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.DEVICE));
    }
  }, [catalogs, dispatch, hasAddress, authenticatedUser]);

  return (
    <div id="employee" className="of-site--employee">
      {authenticatedUser?.userRole ? <Outlet /> : <LoadingDialog loadingText={t.OQUG('Moving to Employee OmaElisa')} />}
    </div>
  );
};
